import { MenuItem, Tab, TabPane } from "semantic-ui-react";
import { NewReferenceLibraryPage } from "./NewReferenceLibraryPage";
import { NewPhysicalLibraryLocationsPage } from "./NewPhysicalLibraryLocationsPage";

export const ReferenceLibrayPageTabMenu = () => {
  const panes = [
    {
      menuItem: <MenuItem>Reference Library</MenuItem>,
      render: () => (
        <TabPane attached={false}>
          <NewReferenceLibraryPage />
        </TabPane>
      ),
    },
    {
      menuItem: <MenuItem>Physical Library Locations</MenuItem>,
      render: () => (
        <TabPane attached={false}>
          <NewPhysicalLibraryLocationsPage />
        </TabPane>
      ),
    },
  ];

  return (
    <>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </>
  );
};
